import {
  Ionicons,
  Zocial,
  Octicons,
  Feather,
  MaterialIcons
} from '@expo/vector-icons';
import * as Font from 'expo-font';
import * as SplashScreen from 'expo-splash-screen';
import * as React from 'react';

// Keep the native splash visible before React mounts; calling this in an effect is too late on iOS.
SplashScreen.preventAutoHideAsync().catch(() => undefined);

export default function useCachedResources() {
  const [isLoadingComplete, setLoadingComplete] = React.useState(false);

  // Load any resources or data that we need prior to rendering the app
  React.useEffect(() => {
    async function loadResourcesAndDataAsync() {
      try {
        // Load fonts
        await Font.loadAsync({
          ...Ionicons.font,
          ...Zocial.font,
          ...Octicons.font,
          ...Feather.font,
          ...MaterialIcons.font,
          // Font Weight 900
          'Montserrat-Black': require('../../assets/fonts/Montserrat-Black.ttf'),
          // Font Weight 700
          'Montserrat-Bold': require('../../assets/fonts/Montserrat-Bold.ttf'),
          // Font Weight 600
          'Montserrat-SemiBold': require('../../assets/fonts/Montserrat-SemiBold.ttf'),
          // Font Weight 500
          'Montserrat-Medium': require('../../assets/fonts/Montserrat-Medium.ttf'),
          // Font Weight 400
          'Montserrat-Regular': require('../../assets/fonts/Montserrat-Regular.ttf'),
          // Font Weight 300
          'Montserrat-Light': require('../../assets/fonts/Montserrat-Light.ttf'),
          // Font Italic 400
          'Montserrat-Italic': require('../../assets/fonts/Montserrat-Italic.ttf')
        });
      } catch (e) {
        // We might want to provide this error information to an error reporting service
        console.warn(e);
      } finally {
        setLoadingComplete(true);
        SplashScreen.hideAsync();
      }
    }

    loadResourcesAndDataAsync();
  }, []);

  return isLoadingComplete;
}
